import { Type, Hash, Calendar, ToggleLeft, List, Braces } from "lucide-react";

export type FieldType = {
  icon: React.JSX.ElementType;
  color: string;
  value: string;
  label: string;
};

export const resolveFieldType = (_type: (typeof fieldTypes)[number]["value"]) => {};

export const fieldTypes = [
  {
    icon: Type,
    color: "bg-blue-50 text-blue-700 border-blue-200",
    value: "string",
    label: "Text",
  },
  {
    icon: Hash,
    color: "bg-green-50 text-green-700 border-green-200",
    value: "number",
    label: "Number",
  },
  {
    icon: ToggleLeft,
    color: "bg-purple-50 text-purple-700 border-purple-200",
    value: "boolean",
    label: "True/False",
  },
  {
    icon: Calendar,
    color: "bg-orange-50 text-orange-700 border-orange-200",
    value: "date",
    label: "Date",
  },
  {
    icon: List,
    color: "bg-yellow-50 text-yellow-700 border-yellow-200",
    value: "enum",
    label: "Choice",
  },
  {
    icon: List,
    color: "bg-pink-50 text-pink-700 border-pink-200",
    value: "array",
    label: "List",
  },
  {
    icon: Braces,
    color: "bg-indigo-50 text-indigo-700 border-indigo-200",
    value: "object",
    label: "Item",
  },
] as const satisfies FieldType[];

type FieldTypeMap = {
  [key in (typeof fieldTypes)[number]["value"]]: (typeof fieldTypes)[number];
};

export const fieldTypeMap: FieldTypeMap = fieldTypes.reduce((acc, fieldType) => {
  acc[fieldType.value] = fieldType;
  return acc;
}, {} as FieldTypeMap);
